import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Nina Care Institut - Soins esthétiques d'exception à Villemoisson-sur-Orge",
  description = "Institut de beauté luxueux à Villemoisson-sur-Orge (91). Soins du visage, épilation, manucure, pédicure, massage avec produits 99% naturels. Prenez rendez-vous dès maintenant !",
  keywords = "institut beauté Villemoisson-sur-Orge, soins visage, épilation, manucure, pédicure, massage, produits naturels, aloe vera, esthétique 91, spa bien-être",
  image = "https://ninacareinstitut.com/logo.png",
  url = "https://ninacareinstitut.com",
  type = "website",
  publishedTime,
  modifiedTime,
  author = "Nina Care Institut",
  category
}) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BeautySalon",
    "name": "Nina Care Institut",
    "description": "Institut de beauté luxueux spécialisé dans les soins du visage, épilation, manucure, pédicure et massage avec produits 99% naturels.",
    "image": image,
    "url": url,
    "telephone": "+33 9 84 63 03 27",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Villemoisson-sur-Orge",
      "postalCode": "91360",
      "addressCountry": "FR",
      "addressRegion": "Île-de-France"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "48.66",
      "longitude": "2.33"
    },
    "priceRange": "€€",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "19:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "09:00",
        "closes": "17:00"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/ninacareinstitut",
      "https://www.instagram.com/ninacareinstitut"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Services beauté",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Soins du visage",
            "description": "Soins anti-âge, hydratants, purifiants avec produits naturels"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Épilation",
            "description": "Épilation à la cire, semi-permanente"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Manucure & Pédicure",
            "description": "Soins des mains et des pieds, pose de vernis semi-permanent"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Massage bien-être",
            "description": "Massages relaxants et anti-stress"
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "127"
    }
  };

  // Article structuré data pour blog
  const articleData = type === 'article' ? {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": title,
    "description": description,
    "image": image,
    "author": {
      "@type": "Organization",
      "name": author
    },
    "publisher": {
      "@type": "Organization",
      "name": "Nina Care Institut",
      "logo": {
        "@type": "ImageObject",
        "url": "https://ninacareinstitut.com/logo.png"
      }
    },
    "datePublished": publishedTime,
    "dateModified": modifiedTime || publishedTime,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": url
    }
  } : null;

  return (
    <Helmet>
      {/* Titre et description de base */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="Nina Care Institut" />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      {category && <meta property="article:section" content={category} />}
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Pour les IA conversationnelles (ChatGPT, Claude, etc.) */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <meta name="bingbot" content="index, follow" />
      
      {/* Données structurées pour IA */}
      <script type="application/ld+json">
        {JSON.stringify(type === 'article' ? articleData : structuredData)}
      </script>
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
      
      {/* Languages alternatives */}
      <link rel="alternate" hrefLang="fr" href={url} />
      <link rel="alternate" hrefLang="fr-FR" href={url} />
      
      {/* Données supplémentaires pour le référencement local */}
      <meta name="geo.region" content="FR-91" />
      <meta name="geo.placename" content="Villemoisson-sur-Orge" />
      <meta name="geo.position" content="48.66;2.33" />
      <meta name="ICBM" content="48.66, 2.33" />
    </Helmet>
  );
};

export default SEO;
